<template>
  <div v-if="isfinalPlayer" class="main">
    <img class="pk" :src="titlePic" alt="">
    <div class="flex">
      <template v-for="(it, idx) in playerList" :key="idx">
        <div v-if="it?.id" class="w-[50%] flex flex-col items-center justify-center mt-[25px] relative">
          <template v-if="winner.length">
            <!-- 平局 2，3，4个玩家的时候，牌一样-->
            <img v-if="winner.length === playerList.length && winner.includes(it.id)" class="tie-pic"
              :src="tiePic" />
            <!-- 输赢 -->
            <img v-else class="res-pic" :src="winner.includes(it.id) ? oResultPic.win : oResultPic.fail" />
          </template>
          <UserAvatar size="45px" :src="it.avatar"/>
          <NameTag :userName="it?.name" :balance="it?.chips || '0'"  atRight :lv="it?.lvl"/>
          <div class="flex relative">
            <TransitionGroup>
              <PokerCard v-for="(card, i) in getCards(it.cards)" class="ml-[-8px]" :key="i" width="42px" real
              :card-name="getCardName(card.suit, card.rank)" />
            </TransitionGroup>
            <CardType v-if="winner.length" :type="it.cardType" is-self />
          </div>
        </div>
      </template>
    </div>
  </div>
  <div class="other-box" v-else>
    <img :src="pk" alt="">
    <div class="text">{{ $t('goldenFlower.finalComp') }}</div>
    <LoadingDots :size="9" color="#FFEFCC" :gap="15"/>
  </div>
</template>

<script setup lang='ts'>
import type { Player } from '../ts/types';
import NameTag from './nameTag.vue'; 
import PokerCard from './pokerCard.vue'; 
import CardType from './cardType.vue'
import winCn from '../img/win-cn.webp'; 
import winEn from '../img/win-en.webp'; 
import failCn from '../img/fail-cn.webp'; 
import failEn from '../img/fail-en.webp'; 
import titleCn from '../img/lask-pk-cn.png';
import titleEn from '../img/lask-pk-en.png';
import tieCn from '../img/tie-cn.png';
import tieEn from '../img/tie-en.png';
import pk from '../img/pk.png'

const $i18n = useNuxtApp().$i18n;
const props = withDefaults(defineProps<{ playerList: Player[], winner?: number[], isfinalPlayer: boolean }>(), {
  winner: () => [],
  playerList: () => []
});
const sLang = computed(()=>{
    return $i18n.locale.value;
});
const oResultPic = computed(()=>{
    if (sLang.value == 'cn'){
        return {
            win: winCn,
            fail: failCn,
        }
    }
    return {
        win: winEn,
        fail: failEn,
    }; 
});
const titlePic = computed(() => sLang.value == 'cn' ? titleCn : titleEn)
const tiePic = computed(() => sLang.value == 'cn' ? tieCn : tieEn)
const getCards =(res)=>{
  if(res?.length) return res;
  return [{}, {}, {}]
}

const getCardName = (suit = '', rank = '') => suit + rank;
</script>

<style scoped lang='scss'>
.main {
  background: radial-gradient(50.85% 48.51% at 52.67% 57.15%, #1A212C 0%, rgba(0, 0, 0, 0.8) 100%);
  width: 100%;
  min-height: 400px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  box-shadow: 0px 0px 15.8px 0px #0F2E10 inset;
  box-shadow: 0px 0px 10px 0px #FDD935;
  border-radius: 12px 12px 0 0;
  padding-bottom: 30px;

  .pk {
    margin: 20px auto;
    height: 100px;
  }

  .res-pic {
    position: absolute;
    z-index: 1;
    width: 60px;
    // bottom: 50px;
    top: -25px;
  }

  .tie-pic {
    position: absolute;
    z-index: 1;
    width: 60px;
    top: -10px;
  }
}

.other-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  .text {
    font-weight: 600;
    line-height: 20px;
    color: #FFAD84;
    margin-bottom: 4px;
  }
}
</style>